import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import { isNotIrisInTool } from '../../helpers/Utils/interactiveVizNav';

let loadYT;
class YouTubePlayer extends PureComponent {
    static propTypes = {
        videoId: PropTypes.string,
        playerId: PropTypes.string,
        enableAutoPlay: PropTypes.bool,
    };

    static defaultProps = {
        enableAutoPlay: false,
        videoId: '',
        playerId: '',
    };

    constructor() {
        super();

        this.loadVideo = this.loadVideo.bind(this);
        this.onPlayerReady = this.onPlayerReady.bind(this);
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
        this.getYoutubeId = this.getYoutubeId.bind(this);
    }

    componentDidMount() {
        if (!loadYT) {
            loadYT = new Promise((resolve) => {
                ScriptLoader.load({
                    src: 'https://www.youtube.com/iframe_api',
                    async: true,
                    defer: false,
                });
                /* istanbul ignore next */
                window.onYouTubeIframeAPIReady = () => resolve(window.YT); // onYouTubeIframeAPIReady will load the video after the script is loaded
            });
        }
        /* istanbul ignore next */
        loadYT.then((YT) => {
            this.loadVideo(YT);
        });
    }

    // This fix is only for IRIS Intool
    componentDidUpdate(prevProps) {
        /* istanbul ignore next */
        if (!isNotIrisInTool()) {
            const { videoId, playerId } = this.props;
            document.getElementById(prevProps.videoId) &&
                document.getElementById(prevProps.videoId).remove();
            const YTDOMPlayer = document.createElement('div');
            YTDOMPlayer.id = `${videoId}-${playerId}`;
            document.querySelector('.ytPlayerContainer').appendChild(YTDOMPlayer);
            this.loadVideo(window.YT);
        }
    }

    onPlayerReady(event) {
        this.props.enableAutoPlay && event.target.playVideo();
    }

    onPlayerStateChange(event) {
        if (event.data === window.YT.PlayerState.ENDED) {
            event.target.stopVideo();
        }
    }

    getYoutubeId(url) {
        // for fetching youtube videoId by passing the youtube url
        let youtubeId = '';
        const splitUrl = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (splitUrl[2] !== undefined) {
            const urlArr = splitUrl[2].split(/[^0-9a-z_-]/i);
            youtubeId = urlArr[0];
        }
        return youtubeId;
    }

    loadVideo(YT) {
        // create Player object
        const { videoId, playerId } = this.props;
        this.player = new YT.Player(`${videoId}-${playerId}`, {
            videoId: this.getYoutubeId(videoId),
            events: {
                onReady: this.onPlayerReady,
                onStateChange: this.onPlayerStateChange,
            },
        });
    }

    render() {
        const { videoId, playerId } = this.props;
        return (
            <div className="ytPlayerContainer">
                <div id={`${videoId}-${playerId}`} />
            </div>
        );
    }
}

export default YouTubePlayer;
